import { useMutation } from 'react-apollo';
import produce from 'immer';

import {
  accountAddressCreate,
  accountAddressUpdate,
} from '../../../../../../graphql/mutations/account';
import { getCheckoutPriceQuery } from '../../../../../../apps/temp/graphql/queries/getCheckoutPrice';
import { UserAddresses } from '../../../../../../graphql/queries/account';

const useCheckoutCartAddress = ({ account, address, checkoutItems }) => {
  const [onCreateAccountAddress] = useMutation(accountAddressCreate);
  const [onUpdateAccountAddress] = useMutation(accountAddressUpdate);

  const createAccountAddress = async (userId, addressData) => {
    const result = await onCreateAccountAddress({
      variables: {
        input: {
          ...addressData,
          account_id: userId,
        },
      },
      update: (store, { data: { accountAddressCreate: response } }) => {
        try {
          const data = store.readQuery({
            query: UserAddresses,
          });

          const { account_address: addr } = response;
          const updatedData = produce(data, draft => {
            draft.me.addresses.unshift(addr);
          });

          store.writeQuery({
            query: UserAddresses,
            data: updatedData,
          });
        } catch {
          //   Nothing to do, query may not be loaded
        }
      },
    });

    return result;
  };
  const updateAccountAddress = async addressData => {
    const result = await onUpdateAccountAddress({
      variables: {
        input: addressData,
      },
      refetchQueries: [
        {
          query: getCheckoutPriceQuery,
          variables: {
            account_id: account?.id,
            address_id: address?.id,
            ...checkoutItems,
          },
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        },
      ],
    });
    return result;
  };

  return {
    createAccountAddress,
    updateAccountAddress,
  };
};

export default useCheckoutCartAddress;
